import { render, staticRenderFns } from "./Siths.vue?vue&type=template&id=14e28df9&"
import script from "./Siths.vue?vue&type=script&lang=js&"
export * from "./Siths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports